<template>
    <div class="app-container-empty">
        <el-row>
            <el-col :style="{width:'calc(20% - 5px)'}">
                <el-row>
                    <el-card class="settingCard">
                        <div slot="header" class="cardHeader">
                            <el-row>
                                <el-col>
                                    <title-icon/><span>{{$t('home.personalCenter')}}</span>
                                </el-col>
                            </el-row>
                        </div>
                        <el-divider content-position="left">{{$t('personal.basicData')}}</el-divider>
                        <div class="setting-item" :class="{itemChosed : settingItem === 1}">
                            <el-link icon="el-icon-camera" type="info" :underline="false" @click="openSetting(1)">
                                {{$t('personal.setting1')}}
                            </el-link>
                        </div>
                        <div class="setting-item" :class="{itemChosed : settingItem === 2}">
                            <el-link icon="el-icon-user" type="info" :underline="false" @click="openSetting(2)">
                                {{$t('personal.setting2')}}
                            </el-link>
                        </div>
                        <div class="setting-item" :class="{itemChosed : settingItem === 3}">
                            <el-link icon="el-icon-lock" type="info" :underline="false" @click="openSetting(3)">
                                {{$t('personal.setting3')}}
                            </el-link>
                        </div>
                        <div class="setting-item" :class="{itemChosed : settingItem === 4}">
                            <el-link icon="el-icon-mobile-phone" type="info" :underline="false" @click="openSetting(4)">
                                {{$t('personal.setting4')}}
                            </el-link>
                        </div>
                        <div v-ioriPermission="'itenant$Service$tenantUserSetting$tenantSetting'">
                            <el-divider content-position="left">{{$t('tenant.setting')}}</el-divider>
                            <div class="setting-item" :class="{itemChosed : settingItem === 5}">
                                <el-link icon="el-icon-camera" type="info" :underline="false" @click="openSetting(5)">
                                    {{$t('personal.setting5')}}
                                </el-link>
                            </div>
                            <div class="setting-item" :class="{itemChosed : settingItem === 6}">
                                <el-link icon="el-icon-postcard" type="info" :underline="false" @click="openSetting(6)">
                                    {{$t('personal.setting6')}}
                                </el-link>
                            </div>
                        </div>
                        <el-divider content-position="left">{{$t('personal.common')}}</el-divider>
                        <div class="setting-item" :class="{itemChosed : settingItem === 10}">
                            <el-link icon="el-icon-setting" type="info" :underline="false" @click="openSetting(10)">
                                {{$t('personal.setting10')}}
                            </el-link>
                        </div>
                        <div class="setting-item" :class="{itemChosed : settingItem === 9}">
                            <el-link icon="el-icon-bell" type="info" :underline="false" @click="openSetting(9)">
                                {{$t('personal.setting9')}}
                            </el-link>
                        </div>
                        <div class="setting-item" :class="{itemChosed : settingItem === 7}">
                            <el-link icon="el-icon-download" type="info" :underline="false" @click="openSetting(7)">
                                {{$t('personal.setting7')}}
                            </el-link>
                        </div>
                        <div class="setting-item" :class="{itemChosed : settingItem === 8}">
                            <el-link icon="el-icon-upload2" type="info" :underline="false" @click="openSetting(8)">
                                {{$t('personal.setting8')}}
                            </el-link>
                        </div>
                    </el-card>
                </el-row>
            </el-col>
            <el-col :style="{width:'calc(80% - 5px)',marginLeft:'10px'}">
                <el-row>
                    <el-card class="settingCard">
                        <div slot="header" class="cardHeader">
                            <title-icon/><span>{{ settingItem | settingItemFilter }}</span>
                        </div>
                        <div>
                            <template v-if="settingItem === 1">
                                <div class="avatar-select">
                                    <crop-upload :url="avatarUrl" @onUpload="uploadAvatar"
                                                 key="personalAvatar"></crop-upload>
                                </div>
                            </template>
                            <template v-else-if="settingItem === 2">
                                <user-profile :currentUser="user"></user-profile>
                            </template>
                            <template v-else-if="settingItem === 3">
                                <user-password></user-password>
                            </template>
                            <template v-else-if="settingItem === 4">
                                <user-phone :currentUser="user"></user-phone>
                            </template>
                            <template v-else-if="settingItem === 5">
                                <div class="avatar-select">
                                    <crop-upload :url="tenantUrl" boxRadius="5%" @onUpload="uploadTenantAvatar"
                                                 key="tenantAvatar"></crop-upload>
                                </div>
                            </template>
                            <template v-else-if="settingItem === 6">
                                <tenant-profile></tenant-profile>
                            </template>
                            <template v-else-if="settingItem === 7">
                                <export-list></export-list>
                            </template>
                            <template v-else-if="settingItem === 8">
                                <import-list></import-list>
                            </template>
                            <template v-else-if="settingItem === 9">
                                <my-notify-list></my-notify-list>
                            </template>
                            <template v-else-if="settingItem === 10">
                                <personalization></personalization>
                            </template>
                        </div>
                    </el-card>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>

    import CropUpload from '@/components/CropUpload'
    import UserPassword from '@/views/business/sso/account/personal/userPassword.vue'
    import UserPhone from '@/views/business/sso/account/personal/userPhone.vue'
    import Personalization from '@/views/business/sso/account/personal/personalization.vue'
    import UserProfile from '@/views/business/sso/account/personal/userProfile.vue'
    import TenantProfile from '@/views/business/sso/account/personal/tenantProfile.vue'
    import ExportList from '@/views/iori/my/export/components/exportList.vue'
    import ImportList from '@/views/iori/my/import/components/importList.vue'
    import MyNotifyList from '@/views/iori/notify/components/myNotifyList.vue'

    let manager = require("@/api/business/sso/personal/personal.js")
    let tenant = require("@/api/iori/tenant.js")

    import i18n from '@/lang'

    export default {
        components: {
            CropUpload,
            UserProfile,
            UserPassword,
            UserPhone,
            TenantProfile,
            ExportList,
            ImportList,
            MyNotifyList,
            Personalization
        },
        filters: {
            // 返回国际化后的设置项
            settingItemFilter(st) {
                return i18n.t('personal.setting' + st);
            },
        },
        data() {
            return {
                // 设置项
                settingItem: 1,
                user: {
                    avatar: null,
                },
                avatarUrl: "",
                tenantUrl: "",
            }
        },
        created() {
            manager.findProfile({userAccount: this.$store.getters.userAccount}).then(r => {
                this.user.userAccount = r.userAccount
                this.user.userName = r.userName
                this.user.phone = r.phone
                this.user.email = r.email
                this.user.avatar = r.avatar
                // 修改头像页面，不展示现在的头像
                // this.avatarUrl = envInfo.bgApp.ssoPath+"/param/avatar?p="+r.avatar
            })
            // 打开指定页面
            this.forwardPage();
        },
        watch: {
            '$route'(to, from) {
                // 路由参数发生变化，打开指定页面
                if (to.query != from.query) {
                    this.forwardPage();
                }
            },
        },
        methods: {
            // 打开指定页面
            forwardPage() {
                let id = this.$route.query.id;
                if (id) {
                    this.openSetting(Number(id));
                }
            },
            openSetting(st) {
                this.settingItem = st;
            },
            uploadAvatar(image) {
                if (image) {
                    manager.updateAvatar({
                        avatarData: encodeURIComponent(image),
                        userAccount: this.user.userAccount,
                        avatar: this.user.avatar
                    }).then(r => {
                        if (r && r.avatar) {
                            this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                            this.$store.dispatch("ChangeAvator", r.avatar)
                        } else {
                            this.$message({type: 'error', message: this.$t('message.uploadFial')});
                        }
                    })
                }
            },
            uploadTenantAvatar(image) {
                if (image) {
                    tenant.updateTenantAvatar({
                        avatarData: encodeURIComponent(image),
                        tenantAvatar: this.$store.getters.constomLogo
                    }).then(r => {
                        if (r && r.tenantAvatar) {
                            this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                            this.$store.dispatch("ChangeTenantAvator", r.tenantAvatar)
                        } else {
                            this.$message({type: 'error', message: this.$t('message.uploadFial')});
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .settingCard >>> .el-card__header {
        padding: 6px 20px;
    }

    .settingCard >>> .el-card__body {
        height: calc(100vh - 140px);
        overflow: scroll;
    }

    .cardHeader {
        line-height: 34px;
        font-weight: 600;
    }

    .setting-item {
        line-height: 32px;
        padding-left: 10px;
    }

    .itemChosed{
        background-color: #8bc1fc21;
        border-radius: 5px;
    }

    .avatar-select {
        width: 600px;
        padding: 10px 180px 10px 0px;
    }
</style>



